<template>
	<div v-if="questionData != null" class="exam_right">
		<div class="border">

		</div>
		<div class="right_main">
			<!-- <div class="right_header">
				<span class="title">试卷</span>
				<div class="btnBox">
					<span @click="select" class="btn">{{!isMake?'标记':'取消标记'}}</span>
				</div>
			</div> -->
			<!--  单选题-->
			<Single v-if="questionData.questionDto.internalTypeId === 1" />
			<!--  多选题-->
			<More v-if="questionData.questionDto.internalTypeId === 2" />
			<!--  判断题-->
			<Judge v-else-if="questionData.questionDto.internalTypeId === 3" />
			<!--  操作题-->
			<!-- <Operation v-else-if="questionData.questionDto.internalTypeId === 9 || questionData.questionDto.internalTypeId === 6" /> -->
			<!--组合题-->
			<!--        <Combination v-else-if="questionData.questionDto.internalTypeId === 6"/>-->
			<!-- 不定项选择题 -->
			<Uncertain v-else-if="questionData.questionDto.internalTypeId === 6"/>
		</div>
		<div class="right_foot">
        <div class="foot_content">
					<el-checkbox v-model="isMake" @change="select">{{!isMake?'标记':'取消标记'}}</el-checkbox>
					<el-button @click="pre" class="left" plain>上一题</el-button>
					<el-button @click="next" class="right" plain>下一题</el-button>
          <!-- <span @click="pre" class="left"><i class="el-icon-arrow-left"></i><p>上一题</p></span>
          <span @click="next" class="right"><i class="el-icon-arrow-right"></i><p>下一题</p></span> -->
        </div>
      </div>
	</div>
</template>

<script>
	import * as api from "../../../../../api/testExamApi";
	import {
		moduleId
	} from "../../../../../store/modules/exam";
	import {
		mapState,
		mapMutations,
		mapActions,
		mapGetters
	} from 'vuex';
	import Single from "./single";
	import Judge from "./judge";
	import Operation from "./operation";
	import More from "./more";
	import Uncertain from "./uncertain"
	export default {
		name: "ExamRight",
		data() {
			return {
				isMake: false,
				examPaperId: 0
			};
		},
		components: {
			Single,
			Judge,
			Operation,
			More,
			Uncertain
		},
		computed: {
			...mapState(moduleId, {
				questionData: state => state.questionData,
				nextData: state => state.paperList,
				paperData: state => state.paperData,
			}),

		},
		watch: {
			questionData(val) {
				console.log(val)
				if (val.makeAnswer) {
					this.isMake = true;
				} else {
					this.isMake = false;
				}
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.nextAnswer()
			})
		},
		methods: {
			...mapMutations(moduleId, ['SET_QUESTION_DATA', 'SET_PAPER_LIST', 'SET_LEFT_INDEX', 'MAKE_ANSWER','SELECT_TEST_DATA','SAVE_PRE_ANSWER','TERM_ANSWER','ARR_ANSWER']),
			...mapActions(moduleId, ['preAnswerNew']),
			pre() {
				if (this.nextData.index === 0) {
					this.$messageError("已是第一题")
				} else {
					let index;
					let promiseList = []
					let arr = []
					this.nextData.data.forEach((item, i) => {
						if (item.id === this.questionData.id) {
							index = i;
						}
					})

					let data = this.nextData.data[index - 1];
					this.nextData.index = index - 1;

					this.SET_PAPER_LIST(this.nextData);
					this.SET_QUESTION_DATA(data);
					if(data.questionDto.internalTypeId == 6){
						this.ARR_ANSWER(data.questionDto.childQuestions);
						[].forEach.call(data.questionDto.childQuestions,(item,index)=>{
							let obj = {
								"paperId": this.$route.query.paperId,
								"questionId": item.id,
								"userId": sessionStorage.getItem('userId'),
								"classId": this.$route.query.classId,
								"examPaperId": this.paperData.examPaperId
							};
							promiseList.push(this.preAnswerNew(obj))
						})
						Promise.all(promiseList).then(res=>{
							[].forEach.call(res,(item,index)=>{
								arr.push(item.data)
								console.log(arr)
								this.TERM_ANSWER(arr)
							})
							this.$forceUpdate();
						})
					}else{
						//切换显示答案
						this.answer();
					}
				}

			},
			nextAnswer() {
				var that = this;
				setTimeout(() => {
					if (that.questionData && that.questionData.makeAnswer) {
						that.isMake = true;
					} else {
						that.isMake = false;
					}
				}, 2000)
			},
			next() {
				if (this.nextData.index === this.nextData.data.length - 1) {
					this.$messageError("已是最后一题")
				} else {
					let index;
					let promiseList = []
					let arr = []
					this.nextData.data.forEach((item, i) => {
						if (item.id === this.questionData.id) {
							index = i;
						}
					})

					let data = this.nextData.data[index + 1];
					this.nextData.index = index + 1;
					this.SET_PAPER_LIST(this.nextData);
					this.SET_QUESTION_DATA(data);
					if(data.questionDto.internalTypeId == 6){
						this.ARR_ANSWER(data.questionDto.childQuestions);
						[].forEach.call(data.questionDto.childQuestions,(item,index)=>{
							let obj = {
								"paperId": this.$route.query.paperId,
								"questionId": item.id,
								"userId": sessionStorage.getItem('userId'),
								"classId": this.$route.query.classId,
								"examPaperId": this.paperData.examPaperId
							};
							promiseList.push(this.preAnswerNew(obj))
						})
						Promise.all(promiseList).then(res=>{
							[].forEach.call(res,(item,index)=>{
								arr.push(item.data)
								this.TERM_ANSWER(arr)
							})
							this.$forceUpdate();
						})
					}else{
						//切换显示答案
						this.answer();
					}
				}
			},
			answer() {
				let obj = {
					"paperId": this.$route.query.paperId,
					"questionId": this.questionData.questionId,
					"userId": sessionStorage.getItem('userId'),
					"classId": this.$route.query.classId,
					"examPaperId": this.paperData.examPaperId
				};
				this.SAVE_PRE_ANSWER(null)
				//上次选择的答案
				this.preAnswerNew(obj).then((result) => {
					console.log(result);
					console.log('我是查看答案')
				});
			},
			select(val) {
				console.log(this.questionData)
				let obj = {
					"examPaperId": this.paperData.examPaperId,
					"subjectId": this.questionData.questionDto.subjectId,
					"classId": this.$route.query.classId,
					"courseId": this.$route.query.id,
					"paperCode": this.$route.query.paperCode,
					"paperId": this.$route.query.paperId,
					"questionId": this.questionData.questionId,
					"questionType": 1,
					"version": this.preAnswerNew.version + 1,
					// "userAnswer":this.radio,
					"score": this.questionData.score,
					"questionStatus": this.questionData.questionDto.status,
					"useTime": "23"
				};
				// let paperObj = {
				// 	"catalogId": "0",
				// 	"classId": this.$route.query.classId,
				// 	"courseId": this.$route.query.id,
				// 	"paperCode": this.$route.query.paperCode,
				// 	"paperId": this.$route.query.paperId,
				// 	"subjectId": this.questionData.questionDto.subjectId,
				// 	"type": 1
				// }
				if (this.questionData.makeAnswer) {
					api.cancelRemarkNew(this.paperData.examPaperId, this.questionData.questionId).then((result) => {
						if (result.code === "0") {
							this.$messageSuccess("标记取消成功！");
							this.isMake = val;
							this.MAKE_ANSWER(this.questionData.questionId + "1");
							// this.SELECT_TEST_DATA(paperObj)
						}
					});
				} else {
					api.remarkNew(this.paperData.examPaperId, this.questionData.questionId, this.questionData.questionDto
						.internalTypeId).then((result) => {
						if (result.code === "0") {
							this.$messageSuccess("标记成功！");
							this.isMake = val;
							this.MAKE_ANSWER(this.questionData.questionId + "0");
						}
					});
				}

			}
		}

	}
</script>

<style lang="scss" scoped>
	.exam_right {
		/*width: calc(100% - 240px);*/
		flex: 1;
		height: 100%;
		box-sizing: border-box;
		padding: 10px;
		padding-top: 0;
		padding-left: 32px;
		padding-right: 64px;
		display: flex;
		justify-content: space-between;
		background: #DCEAF6;

		.border {
			width: 0;
			height: 100%;
			border-left: 2px solid #B2C6F7;
		}

		.right_main {
			width: 100% !important;
			height: calc(100% - 52px);
			// overflow: auto;

			#title {
				width: 95%;
				margin: auto;
				border-bottom: 1px dashed black;
			}

		}

		.right_foot {
			position: fixed;
			width: 26%;
			height: 40px;
			margin: auto;
			left: 400px;
			bottom: 0;
			.foot_content {
				width: 80%;
				height: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				.left {
					width: 80px;
					height: 28px;
					background: linear-gradient(180deg, #F3F6FB 0%, #BFCEF2 100%);
					border-radius: 3px;
					border: 2px solid #CBDBF8;
					font-size: 12px;
					cursor: pointer;
					line-height: 28px;
					padding: 0;
				}

				.center {
					width: 32px;
					height: 32px;
					line-height: 32px;
					display: inline-block;
					border: 1px solid #999999;
					border-radius: 50%;
					margin-top: 15px;
					font-size: 18px;
					cursor: pointer;

					&:hover {
						border-color: #5397F7;
						background: #5397F7;

						i {
							color: white;
						}
					}

					p {

						width: 50px;
						font-size: 12px;
						text-indent: -20px;
					}
				}

				.right {
					width: 80px;
					height: 28px;
					background: linear-gradient(180deg, #F3F6FB 0%, #BFCEF2 100%);
					border-radius: 3px;
					border: 2px solid #CBDBF8;
					font-size: 12px;
					cursor: pointer;
					line-height: 28px;
					padding: 0;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testSumulationComponentNew/ExamRight.vue